// extracted by mini-css-extract-plugin
export default {"link-toitem":"markdown_link-toitem__OkA7v"};